import { EmptyGridCell } from 'src/shared/components/atoms/emptyGridCell';
import { Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MemberInvoiceItemFamilyMember } from '../models/memberInvoiceItem';

type MemberInvoiceSelectionFamilyPopoverProps = {
  familyMembers: MemberInvoiceItemFamilyMember[];
};

export const MemberInvoiceSelectionFamilyTooltip = (props: MemberInvoiceSelectionFamilyPopoverProps) => {
  const { familyMembers } = props;
  const { t } = useTranslation(['member']);

  let familyMemberNames = '';

  if (familyMembers != null && familyMembers.length > 0) {
    familyMemberNames = familyMembers
      .map((member) => `${member.firstName} ${member.lastName} ${member.isMainMember ? `(${t('member:memberAdvancedSearch.isMainMember')})` : ''}`)
      .join('\n');
  }

  return (
    <Box>
      {familyMembers != null && familyMembers && familyMembers.length > 0 ? (
        <Tooltip title={<Box sx={{ whiteSpace: 'pre-line' }}>{familyMemberNames}</Box>} arrow>
          <Box>
            {familyMembers.length === 1 ? `${familyMembers.length} ${t('invoice:Member')}` : `${familyMembers.length} ${t('invoice:Members')}`}
          </Box>
        </Tooltip>
      ) : (
        <EmptyGridCell />
      )}
    </Box>
  );
};
